import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { RefreshCcw, Trash2 } from 'lucide-react';
import { API_URL } from '../utils/cartApi';

const AdminRecycleBin = () => {
  const [items, setItems] = useState([]);

  useEffect(() => { loadRecycled(); }, []);

  const loadRecycled = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/products/recycled`);
      setItems(res.data);
    } catch (err) {
      console.error("Error fetching recycled items", err);
    }
  };

  const restoreItem = async (id) => {
    await axios.put(`${API_URL}/api/products/restore/${id}`);
    loadRecycled();
    alert("Saree restored to Stock Management!");
  };

  const permanentDelete = async (id) => {
    if (window.confirm("Delete permanently? This cannot be undone.")) {
      await axios.delete(`${API_URL}/api/products/permanent/${id}`);
      loadRecycled();
    }
  };

  return (
    <div className="p-6 bg-[#f5f2e8] min-h-screen">
      <h2 className="text-2xl font-bold text-maroon mb-6 uppercase tracking-wider font-serif">Recycle Bin</h2>
      <p className="text-[10px] text-gray-500 mb-4 italic font-bold">* Items here will be automatically deleted after 30 days.</p>
      
      <div className="bg-white border shadow-sm rounded overflow-hidden">
        <table className="w-full text-left text-sm">
          <thead className="bg-gray-100 text-maroon font-bold uppercase text-xs border-b">
            <tr>
              <th className="p-4">Saree</th>
              <th>Color</th>
              <th>Price</th>
              <th className="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan="4" className="p-10 text-center text-gray-400 italic">Recycle bin is empty.</td></tr>
            ) : (
              items.map(p => (
                <tr key={p._id} className="border-b hover:bg-gray-50 transition">
                  <td className="p-4 flex items-center">
                    <img src={p.images?.[0] || 'https://via.placeholder.com/50'} className="w-10 h-12 mr-3 object-cover border" alt=""/>
                    <div>
                        <div className="font-bold">{p.name}</div>
                        <div className="text-[10px] text-gray-400">{p.sareeId}</div>
                    </div>
                  </td>
                  <td className="capitalize">{p.color}</td>
                  <td className="font-bold text-maroon">₹{p.price}</td>
                  <td className="text-center space-x-6">
                    <button onClick={() => restoreItem(p._id)} className="text-green-600 hover:text-green-800 transition font-bold uppercase text-[10px] inline-flex items-center">
                      <RefreshCcw size={14} className="mr-1"/> Restore
                    </button>
                    <button onClick={() => permanentDelete(p._id)} className="text-red-600 hover:text-red-900 transition font-bold uppercase text-[10px] inline-flex items-center">
                      <Trash2 size={14} className="mr-1"/> Delete Forever
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminRecycleBin;